<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">Edit Behfa Rule</h5>
      <form  >
          <div class="row">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1">Title</label>
              <input [(ngModel)]="Title" name="Title" type="text" class="form-control"  placeholder="Type here...">
            </div>

          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1">Description</label>
              <ckeditor name="editorData" [(ngModel)]="model.editorData" [config]="config" [editor]="Editor"></ckeditor>
            </div>
          </div>

          <br/>
          <br/>

          <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
          <button *ngIf="!InProccessing" type="button" (click)="onSubmitForm()"  class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Register Information </button>
          <button routerLink="/BehfaRuleAdmin" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
      </form>
  </div>
</div>
